import CardDiv from "modules/common/card-div/CardDiv";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import ReactDatePicker from "react-datepicker";
import {
  useZohoData,
  useCreditNoteData,
  useErroredZohoInvoices,
  useErroredZohoCreditNotes,
} from "./store";
import ZohoTable from "./ZohoTable";

function Zoho() {
  const { zohoData, zohoDataError, zohoDataLoading, fetchZohoData } =
    useZohoData();

  const {
    creditNoteData,
    creditNoteDataError,
    creditNoteDataLoading,
    fetchCreditNoteData,
  } = useCreditNoteData();

  const {
    erroredZohoInvoices,
    erroredZohoInvoicesError,
    erroredZohoInvoicesLoading,
    fetchErroredZohoInvoices,
  } = useErroredZohoInvoices();

  const {
    erroredZohoCreditNotes,
    erroredZohoCreditNotesError,
    erroredZohoCreditNotesLoading,
    fetchErroredZohoCreditNotes,
  } = useErroredZohoCreditNotes();

  const [page, setPage] = useState(1);
  const date = new Date();
  const [startDate, setStartDate] = useState(date.setDate(date.getDate() - 1));
  const [endDate, setEndDate] = useState(new Date());
  const onChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  useEffect(() => {
    setActiveTab("zoho");
    getAllZohoData(
      moment(startDate).format("YYYY-MM-DD") + `T18:30:00.000Z`,
      moment(endDate).format("YYYY-MM-DD") + `T18:29:59.999Z`
    );
    setPage(1);
  }, []);

  const [activeTab, setActiveTab] = useState();
  const getAllZohoData = (pageNUmber=1, startFilterDate, endFilterDate) => {
    fetchZohoData(pageNUmber, startFilterDate, endFilterDate);
    fetchCreditNoteData(pageNUmber, startFilterDate, endFilterDate);
    fetchErroredZohoInvoices(pageNUmber, startFilterDate, endFilterDate);
    fetchErroredZohoCreditNotes(pageNUmber, startFilterDate, endFilterDate);
  };
  useEffect(() => {
    getAllZohoData(
      page,
      moment(startDate).format("YYYY-MM-DD") + `T18:30:00.000Z`,
      moment(endDate).format("YYYY-MM-DD") + `T18:29:59.999Z`
    );
  }, [page]);

  return (
    <div>
      <div className="d-flex gap-3">
        <div
          onClick={() => {
            setActiveTab("zoho");
          }}
          className="flex-1"
        >
          <CardDiv
            title={<p>Zoho Data</p>}
            component={<p>Data : {zohoData?.pagination?.rowCount}</p>}
          />
        </div>
        <div
          onClick={() => {
            setActiveTab("creditNote");
          }}
          className="flex-1"
        >
          <CardDiv
            title={<p>Credit-Note Data</p>}
            component={<p>Data : {creditNoteData?.pagination?.rowCount}</p>}
          />
        </div>
        <div
          onClick={() => {
            setActiveTab("erroredInvoice");
          }}
          className="flex-1"
        >
          <CardDiv
            title={<p>Get Errored Zoho Invoices</p>}
            component={
              <p>Data : {erroredZohoInvoices?.pagination?.rowCount}</p>
            }
          />
        </div>
        <div
          onClick={() => {
            setActiveTab("erroredCreditNote");
          }}
          className="flex-1"
        >
          <CardDiv
            title={<p>Get Errored Zoho Credit Notes</p>}
            component={
              <p>Data : {erroredZohoCreditNotes?.pagination?.rowCount}</p>
            }
          />
        </div>
        <div className="flex-1">
          <CardDiv
            title={<p>filter</p>}
            component={
              <div className="d-flex gap-2">
                <ReactDatePicker
                  selected={startDate}
                  onChange={onChange}
                  startDate={startDate}
                  formatWeekDay={(day) => day.slice(0, 3)}
                  endDate={endDate}
                  selectsRange
                  dateFormat="dd/MM/yyyy"
                  className="form-control"
                />
                <Button
                  onClick={() => {
                    getAllZohoData(
                      moment(startDate).format("YYYY-MM-DD") + `T18:30:00.000Z`,
                      moment(endDate).format("YYYY-MM-DD") + `T18:29:59.999Z`
                    );
                  }}
                  disabled={!startDate || !endDate}
                >
                  Submit
                </Button>
              </div>
            }
          />
        </div>
      </div>
      <div>
        {activeTab === "zoho" && (
          <ZohoTable
            data={zohoData.data}
            loading={zohoDataLoading}
            pagination={zohoData.pagination}
            error={zohoDataError}
            setPage={setPage}
          />
        )}
        {activeTab === "creditNote" && (
          <ZohoTable
            data={creditNoteData.data}
            loading={creditNoteDataLoading}
            pagination={creditNoteData.pagination}
            error={creditNoteDataError}
            setPage={setPage}
          />
        )}
        {activeTab === "erroredInvoice" && (
          <ZohoTable
            data={erroredZohoInvoices.data}
            loading={erroredZohoInvoicesLoading}
            pagination={erroredZohoInvoices.pagination}
            error={erroredZohoInvoicesError}
            setPage={setPage}
          />
        )}
        {activeTab === "erroredCreditNote" && (
          <ZohoTable
            data={erroredZohoCreditNotes.data}
            loading={erroredZohoCreditNotesLoading}
            pagination={erroredZohoCreditNotes.pagination}
            error={erroredZohoCreditNotesError}
            setPage={setPage}
          />
        )}
      </div>
    </div>
  );
}

export default Zoho;
